import Phaser from 'phaser';
import BaseSoupGameScene from './BaseSoupGameScene';

import { createGameLevels, gameAssets } from './GameFunctions';

export default class MyPlateScene extends BaseSoupGameScene {
    //create const for name
    name = "MyPlateScene";

    constructor() {
        super('MyPlateScene');

        // this.resizeGame = this.resizeGame.bind(this);
    }

    //scene started
    init() {
        super.init();
        
        console.log('MyPlateScene init');
    }

    handleStepChange(currentLevel, currentLevelData, currentStep, currentStepData) {
        //check if this.currentStepData.scene is different new currentStepData.scene. If it is we need to change scenes
        if (currentStepData?.scene !== this.name) {
            return;
        }

        //loop through the gameObjects and set the visibility based on the currentStepData.navID
        //if the gameObject has a navID set and it matches the currentStepData.navID, set the visibility to true otherwise set it to false (only if it has a navID)
        this.handleGameObjectSubSectionVisibility();

    }

    preload() {
        super.preload();
    }

    async create() {
        console.log('MyPlateScene create');
        super.create();

        let scene = this;

        let game = this.game;

        this.gameObjects = await createGameLevels(scene, game, this.name);

        this.handleGameObjectSubSectionVisibility();

        this.game.events.emit('phaserScenePreloadEnd');
    }

    shutdown() {
        console.log('MyPlateScene shutdown');
        // Stop all 
        // active tweens
        this.tweens.killAll();
    }

    destroy() {
        this.tweens.killAll();

        this.steam?.destroy();

        super.destroy();
    }

}